import { render, staticRenderFns } from "./CertificateForm.vue?vue&type=template&id=0dd49090&"
import script from "./CertificateForm.vue?vue&type=script&lang=js&"
export * from "./CertificateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd49090')) {
      api.createRecord('0dd49090', component.options)
    } else {
      api.reload('0dd49090', component.options)
    }
    module.hot.accept("./CertificateForm.vue?vue&type=template&id=0dd49090&", function () {
      api.rerender('0dd49090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/CertificateForm.vue"
export default component.exports